/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Use_4_ValueInputs */

const en_svc_integration_use_4_value = /** @type {(inputs: Svc_Integration_Use_4_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search, summaries or drafting added to your own software, behind your login.`)
};

const lv_svc_integration_use_4_value = /** @type {(inputs: Svc_Integration_Use_4_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meklēšana, kopsavilkumi vai tekstu sagatavošana Jūsu pašu programmatūrā, kurai lietotāji piekļūst ar savu kontu.`)
};

/**
* | output |
* | --- |
* | "Search, summaries or drafting added to your own software, behind your login." |
*
* @param {Svc_Integration_Use_4_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_use_4_value = /** @type {((inputs?: Svc_Integration_Use_4_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Use_4_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_use_4_value(inputs)
	return en_svc_integration_use_4_value(inputs)
});